import {
  Avatar,
  Box,
  CardMedia,
  Grid,
  IconButton,
  LinearProgress,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import contentImgPlaceholder from "../../../assets/images/contentImgPlaceholder.svg";
import { getContent, getContentComments, getContentGroup } from "../../../utils/apiHelperInternal";
import TwitterContentData from "../TwitterContentData/TwitterContentData";
import {
  formatNumber,
  getNewImageUrl,
  isEmpty,
  timeConvert,
} from "../../../utils/helper";
import "./AccountContentData.scss";
import { useRef } from "react";
import { POLL_DURARION, POLL_INTERVAL } from "../../../utils/constants";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const CONTENT_FEED_ATTRIBUTES = {
  thumbnail_url: "thumbnail_url",
  title: "title",
  likes: "likes",
  comments: "comments",
  views: "views",
  watch_time: "watch_time",
  impressions: "impressions",
  reach: "reach",
  shares: "shares",
  recent_comments: "recent_comments"
};

const CONTENT_FEED_MAPPING = {
  YouTube: [
    CONTENT_FEED_ATTRIBUTES.thumbnail_url,
    CONTENT_FEED_ATTRIBUTES.title,
    CONTENT_FEED_ATTRIBUTES.likes,
    CONTENT_FEED_ATTRIBUTES.comments,
    CONTENT_FEED_ATTRIBUTES.views,
    CONTENT_FEED_ATTRIBUTES.watch_time,
    CONTENT_FEED_ATTRIBUTES.recent_comments
  ],
  Instagram: [
    CONTENT_FEED_ATTRIBUTES.thumbnail_url,
    CONTENT_FEED_ATTRIBUTES.title,
    CONTENT_FEED_ATTRIBUTES.likes,
    CONTENT_FEED_ATTRIBUTES.comments,
    CONTENT_FEED_ATTRIBUTES.views,
    CONTENT_FEED_ATTRIBUTES.impressions,
    CONTENT_FEED_ATTRIBUTES.reach,
    CONTENT_FEED_ATTRIBUTES.recent_comments
  ],
  TikTok: [
    CONTENT_FEED_ATTRIBUTES.thumbnail_url,
    CONTENT_FEED_ATTRIBUTES.title,
    CONTENT_FEED_ATTRIBUTES.likes,
    CONTENT_FEED_ATTRIBUTES.comments,
    CONTENT_FEED_ATTRIBUTES.views,
    CONTENT_FEED_ATTRIBUTES.shares,
  ],
  Twitter: [
    CONTENT_FEED_ATTRIBUTES.thumbnail_url,
    CONTENT_FEED_ATTRIBUTES.title,
    CONTENT_FEED_ATTRIBUTES.likes,
    CONTENT_FEED_ATTRIBUTES.shares,
  ],
  Facebook: [
    CONTENT_FEED_ATTRIBUTES.thumbnail_url,
    CONTENT_FEED_ATTRIBUTES.title,
    CONTENT_FEED_ATTRIBUTES.likes,
    CONTENT_FEED_ATTRIBUTES.comments,
    CONTENT_FEED_ATTRIBUTES.views,
    CONTENT_FEED_ATTRIBUTES.impressions,
    CONTENT_FEED_ATTRIBUTES.reach,
  ],
  others: [
    CONTENT_FEED_ATTRIBUTES.thumbnail_url,
    CONTENT_FEED_ATTRIBUTES.title,
    CONTENT_FEED_ATTRIBUTES.likes,
    CONTENT_FEED_ATTRIBUTES.comments,
    CONTENT_FEED_ATTRIBUTES.views,
    CONTENT_FEED_ATTRIBUTES.impressions,
    CONTENT_FEED_ATTRIBUTES.reach,
  ],
};

function AccountContentData({ selectedPlatform, title, titleIcon }) {
  const [content, setContent] = useState(null);
  const [currWorkPlatformMetrics, setCurrWorkPlatformMetrics] = useState(null);
  const [workPlatformName, setWorkPlatformName] = useState(null);
  const isCompMounted = useRef();
  const pollId = useRef();
  const pollStartTime = useRef();
  const scrollContainer = useRef();
  const mobileBreakPoint = useMediaQuery("(max-width:430px)");

  async function getFeed() {
    const contentDataRes = await getContent(selectedPlatform);
    const contentGroupDataRes = await getContentGroup(selectedPlatform);
    let allComments = [];
    for (const content of contentDataRes.data) {
      const commentResponse = await getContentComments(selectedPlatform, content.id);
      if (commentResponse.data) {
        allComments = [...allComments, ...commentResponse.data];
      }
    }
    contentDataRes.data = contentDataRes.data.map(content => ({
      ...content,
      comments: allComments.filter(comment => comment.content.id === content.id)
    }));
    if (isCompMounted.current)
      setContent({
        data: [...contentDataRes.data, ...contentGroupDataRes.data],
      });
  }
  useEffect(() => {
    isCompMounted.current = true;
    if (selectedPlatform) {
      getFeed();
      pollStartTime.current = Date.now();
      pollId.current = window.setInterval(() => {
        if (Date.now() - pollStartTime.current < POLL_DURARION) getFeed();
        else window.clearInterval(pollId.current);
      }, POLL_INTERVAL);
    }
    return () => {
      isCompMounted.current = false;
      window.clearInterval(pollId.current);
    };
  }, [selectedPlatform]);

  useEffect(() => {
    if (content && content.data.length > 0) {
      const work_platform_name = content.data[0].work_platform.name;
      if (CONTENT_FEED_MAPPING.hasOwnProperty(work_platform_name)) {
        setCurrWorkPlatformMetrics(CONTENT_FEED_MAPPING[work_platform_name]);
      } else {
        setCurrWorkPlatformMetrics(CONTENT_FEED_MAPPING["others"]);
      }
      setWorkPlatformName(work_platform_name);
    }
  }, [content]);

  return (
    <>
      {content &&
        content.data.length > 0 &&
        currWorkPlatformMetrics &&
        workPlatformName === "Twitter" && (
          <TwitterContentData
            content={content}
            title={title}
            titleIcon={titleIcon}
          />
        )}
      {content &&
        content.data.length > 0 &&
        currWorkPlatformMetrics &&
        workPlatformName !== "Twitter" && (
          <Box className="container contentMainContainer">
            <Box className="mainHeading">
              {" "}
              <img style={{ marginRight: "12px" }} src={titleIcon} />
              {title}
            </Box>
            <hr
              style={{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "rgba(0, 0, 0, 0.12)",
              }}
            />
            <Box
              sx={
                mobileBreakPoint
                  ? {
                      display: "flex",
                      flexDirection: "row",
                      overflowX: "auto",
                    }
                  : {
                      display: "flex",
                      flexDirection: "row",
                      overflowX: "auto",
                      marginLeft: "-45px",
                      marginRight: "-45px",
                    }
              }
              className="content-scroll-container"
              ref={scrollContainer}
            >
              <IconButton
                aria-label="left-scroll"
                className="left-scroll-btn"
                onClick={() => {
                  scrollContainer.current.scrollBy(-400, 0);
                }}
              >
                <ChevronLeftIcon />
              </IconButton>
              <IconButton
                aria-label="left-scroll"
                className="right-scroll-btn"
                onClick={() => {
                  scrollContainer.current.scrollBy(400, 0);
                }}
              >
                <ChevronRightIcon />
              </IconButton>
              {content.data.map((content, index) => (
                <Box className="contentContiner">
                  <Box sx={{ position: "relative" }}>
                    {" "}
                    <CardMedia
                      alt="Profile Pic"
                      image={
                        getNewImageUrl(content.thumbnail_url) ||
                        contentImgPlaceholder
                      }
                      className="contentPic"
                    />
                    <div className="imgGradient">
                      <p className="text-truncate">{content.title}</p>
                    </div>
                  </Box>
                  
                  <Box className="contentInfo" 
                     sx={{
                       width: currWorkPlatformMetrics.includes(CONTENT_FEED_ATTRIBUTES.recent_comments) ? 403 : 160,
                       ...(currWorkPlatformMetrics.includes(CONTENT_FEED_ATTRIBUTES.recent_comments) && {
                         display: 'flex',
                         gap: '22px',
                         flexDirection: 'row'
                       }),
                  }}
                  >
                  <Box className="mainInfo">
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.likes
                    ) && (
                      <Box>
                        <Box>LIKES</Box>
                        <Box>
                          {content.engagement.like_count !== null
                            ? formatNumber(content.engagement.like_count)
                            : "-"}
                        </Box>
                      </Box>
                    )}
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.comments
                    ) && (
                      <Box>
                        <Box>COMMENTS</Box>
                        <Box>
                          {content.engagement.comment_count !== null
                            ? formatNumber(content.engagement.comment_count)
                            : "-"}
                        </Box>
                      </Box>
                    )}
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.views
                    ) && (
                      <Box>
                        <Box>VIEWS</Box>
                        <Box>
                          {content.engagement.view_count !== null
                            ? formatNumber(content.engagement.view_count)
                            : "-"}
                        </Box>
                      </Box>
                    )}
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.impressions
                    ) && (
                      <Box>
                        <Box>IMPRESSIONS</Box>
                        <Box>
                          {content.engagement.impression_organic_count !== null
                            ? formatNumber(
                                content.engagement.impression_organic_count
                              )
                            : "-"}
                        </Box>
                      </Box>
                    )}
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.reach
                    ) && (
                      <Box>
                        <Box>REACH</Box>
                        <Box>
                          {content.engagement.reach_organic_count !== null
                            ? formatNumber(
                                content.engagement.reach_organic_count
                              )
                            : "-"}
                        </Box>
                      </Box>
                    )}
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.watch_time
                    ) && (
                      <Box>
                        <Box>WATCH TIME</Box>
                        <Box>
                          {content.engagement.watch_time_in_hours !== null
                            ? timeConvert(
                                content.engagement.watch_time_in_hours
                              )
                            : "-"}
                        </Box>
                      </Box>
                    )}
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.shares
                    ) && (
                      <Box>
                        <Box>SHARES</Box>
                        <Box>
                          {content.engagement.share_count !== null
                            ? formatNumber(content.engagement.share_count)
                            : "-"}
                        </Box>
                      </Box>
                    )}
                  </Box>
                  <Box className="recent-comment-info">
                    {currWorkPlatformMetrics.includes(
                      CONTENT_FEED_ATTRIBUTES.recent_comments
                    ) && (
                      <Box>
                        <Box>RECENT COMMENTS
                          <Box className="comments-container">
                            {!isEmpty(content.comments)
                              ? content.comments.slice(0, 5).map(comment => {
                                  return (
                                      <span key={comment.id}>
                                        {comment.commenter_username ? comment.commenter_username : "[Username unavailable]"} <span>{comment.text.length > 40 ? comment.text.substring(0, 40) + '...' : comment.text}</span>
                                      </span>
                                  )
                                })
                              : <span>-</span>}
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                  </Box>
                </Box>
              ))}
              <Box className="linearGradientRight"></Box>
              <Box className="linearGradientLeft"></Box>
            </Box>
          </Box>
        )}
    </>
  );
}

export default AccountContentData;
